import { useEffect, useRef } from "react";
import { Link } from "react-router-dom";

function useVideoVisibility(threshold = 0.3) {
  const ref = useRef(null);

  useEffect(() => {
    const video = ref.current;
    if (!video) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      },
      { threshold }
    );

    observer.observe(video);
    return () => observer.disconnect();
  }, []);

  return ref;
}

export default function SportyNerdDemo({
  iconUrl,
  videoUrl,
  link,
  linkText = "Try the Demo-!",
  joyStick = true,
  controls = false,
}) {
  const videoRef = useVideoVisibility();

  const bucketUrl = "https://storage.googleapis.com/sportynerd-bucket1";

  return (
    <div
      className="sportyNerdDemoContainer"
      style={{
        position: "relative",
        display: "flex",
        background: "var(--black8)",
        border: "1px solid var(--bg4)",
        paddingLeft: "0px",
        paddingTop: "8px",
        margin: "40px 0px",
        borderRadius: "4px 4px 0px 0px",
      }}
    >
      <div
        style={{
          position: "absolute",
          top: "2px",
          left: "4px",
          display: "flex",
          flexDirection: "row",
          gap: "2px",
        }}
      >
        <span style={{ width: "4px", height: "4px", background: "white", borderRadius: "50%" }} />
        <span style={{ width: "4px", height: "4px", background: "white", borderRadius: "50%" }} />
        <span style={{ width: "4px", height: "4px", background: "white", borderRadius: "50%" }} />
      </div>

      <video
        ref={videoRef}
        src={bucketUrl + videoUrl}
        style={{ width: "100%" }}
        controls = { controls }
        muted
        loop
        playsInline
      />

      <Link
        to={link}
        target="_blank"
        style={{
          position: "absolute",
          bottom: joyStick ? "-60px" : "-40px",
          left: "50%",
          transform: "translateX(-50%)",
          zIndex: 999,
          display: "flex",
          flexDirection: "column",
        }}
      >
        {joyStick && (
          <img src={bucketUrl + iconUrl} style={{ width: "120px", height: "120px" }} />
        )}
        <p
          style={{
            textDecoration: "underline",
            fontSize: "var(--font-size-tiny)",
            color: "var(--black)",
          }}
        >
          {linkText}
        </p>
      </Link>
    </div>
  );
}